import { proxy } from 'valtio'

/*
 * The line whose documents the side panel shows. The panel and the lines are
 * siblings — the grid's cursor or the card's open line sets it, the panel
 * reads it — and it is no part of the record, so it stays out of the form
 * store. `null` until a line is picked; the panel then shows the first.
 * `recordId` is the record the index belongs to: another one starts afresh.
 */
export const documentLine = proxy({ index: null, recordId: undefined })

export const showLineDocuments = (index) => { documentLine.index = index }
